import React from "react";
import "../css/HomePage.css";

export default function BannerSection() {
  return (
    <section className="mtg-banner">
      {/* ===== BACKGROUND SHAPE ===== */}
      <img
        className="mtg-blob"
        src="https://mentortogether.org/wp-content/uploads/2024/12/bg2.svg"
        alt=""
        aria-hidden="true"
        loading="lazy"
        decoding="async"
      />

      {/* ===== HERO CONTENT ===== */}
      <div className="mtg-banner-grid">
        <div className="mtg-blue-panel">
          <h1 className="mtg-h1">
            A mentor in<br />your pocket!
          </h1>
          <p className="mtg-sub">
            Career mentorship for young minds anytime, anywhere from trusted
            experts via our Android app or web platform.
          </p>
          <a className="mtg-cta" href="/signin" rel="noopener noreferrer">
            EXPLORE THE APP
          </a>
        </div>

        <figure className="mtg-hero">
          <img
            src="https://mentortogether.org/wp-content/uploads/2024/12/Screenshot-2024-10-21-at-2.00.36%E2%80%AFPM-1-1024x900.png"
            alt="Mentee showing the Mentor To Go app on a phone"
            loading="lazy"
            decoding="async"
          />
        </figure>
      </div>

      {/* ===== TAGLINE ===== */}
      <div className="mtg-tagline">
        <h2>
          <span className="mtg-pill">Mentor To Go</span> helps students connect
          with industry mentors, engage in planned learning, and achieve their
          goals.
        </h2>
      </div>
    </section>
  );
}
